(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/mega-menu
 * -----------------------------------------------------------------------------
 * @version 0.1.5
 * @overview Mega menu accessibility helpers.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("mega-menu") === undefined) {
    class MegaMenu extends HTMLElement {
        constructor(){
            super();
            this.parent = this.querySelector('[aria-haspopup="true"]');
            this.submenu = this.querySelector('[role="presentation"]');
            this.keyupEsc = this.keyupEsc.bind(this);
            this.focusOut = this.focusOut.bind(this);
            this.focusKeydown = this.focusKeydown.bind(this);
            this.mouseOver = this.mouseOver.bind(this);
            this.parent.addEventListener("focus", this.parentLinkFocus.bind(this));
            this.parent.addEventListener("mouseover", this.mouseOver);
        }
        keyupEsc(event) {
            if (event.keyCode !== 27) return;
            this.close();
            this.parent.focus();
        }
        parentLinkFocus() {
            this.parent.addEventListener("keydown", this.focusKeydown);
        }
        focusKeydown(event) {
            if (event.keyCode !== 13) return;
            event.preventDefault();
            this.parent.getAttribute("aria-expanded") === "true" ? this.close() : this.open();
        }
        focusOut(event) {
            if (this.submenu.contains(event.relatedTarget)) return;
            this.close();
            this.parent.focus();
            this.parent.removeEventListener("click", this.focusKeydown);
        }
        mouseOver(event) {
            document.querySelectorAll("mega-menu").forEach((item)=>item.parent !== event.target && item.close());
        }
        open() {
            this.parent.setAttribute("aria-expanded", true);
            this.addEventListener("focusout", this.focusOut);
            document.addEventListener("keyup", this.keyupEsc);
        }
        close() {
            this.parent.setAttribute("aria-expanded", false);
            this.removeEventListener("focusout", this.focusOut);
            document.removeEventListener("keyup", this.keyupEsc);
        }
    }
    customElements.define("mega-menu", MegaMenu);
}



})();
